"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rehydrateValue = exports.storeForHydration = exports.getInitialDataForHydration = exports.isBrowser = exports.isNode = exports.isSSR = void 0;
var get_1 = require("./get");
/**
 * Check if the app is running in SSR context
 * @returns boolean
 */
function isSSR() {
    var _a, _b, _c;
    if (typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.__SSR__) !== 'undefined') {
        return !!globalThis.__SSR__;
    }
    // Node is always on the server side
    if (isNode() === true) {
        return true;
    }
    var ssrQueryParam = (_c = new URLSearchParams((_b = (_a = globalThis.location) === null || _a === void 0 ? void 0 : _a.search) !== null && _b !== void 0 ? _b : '')
        .get('ssr')) === null || _c === void 0 ? void 0 : _c.toLowerCase();
    return ssrQueryParam === '1' || ssrQueryParam === 'true';
}
exports.isSSR = isSSR;
/**
 * Check if the app is running in Node.js context
 * @returns boolean
 */
function isNode() {
    var _a;
    return typeof process !== 'undefined' && ((_a = process.release) === null || _a === void 0 ? void 0 : _a.name) === 'node';
}
exports.isNode = isNode;
/**
 * Check if the app is running in browser context
 * @returns boolean
 */
function isBrowser() {
    return (typeof globalThis.window !== 'undefined' &&
        typeof globalThis.document !== 'undefined');
}
exports.isBrowser = isBrowser;
/**
 * Get initial data saved during pre-rendering.
 * Developers shouldn't be accessing this API directly.
 * @private
 * @returns All initial data
 */
function getInitialDataForHydration() {
    return globalThis.__INITIAL__DATA__ || {};
}
exports.getInitialDataForHydration = getInitialDataForHydration;
/**
 * Store data for hydration.
 * Make sure you use unique keys or other data may be overwritten.
 * @param key unique data identifier
 * @param value value to be stored
 * @returns initial data
 */
function storeForHydration(key, value) {
    var _a;
    if (!isSSR()) {
        // gracefully exit if CSR is on
        return;
    }
    var previousData = getInitialDataForHydration();
    var newData = __assign(__assign({}, previousData), (_a = {}, _a[key] = value, _a));
    globalThis.__INITIAL__DATA__ = newData;
    return newData;
}
exports.storeForHydration = storeForHydration;
/**
 * Get data for hydration.
 * You can use this for setting the initial state values.
 * @param key data identifier. You can also nest keys (e.g. "key.child")
 */
function rehydrateValue(key) {
    var data = getInitialDataForHydration();
    return (0, get_1.get)(data, key);
}
exports.rehydrateValue = rehydrateValue;
